import { queryOptions, useQuery } from '@tanstack/react-query'

import { userApi } from '../api/userApi'

export const getUserQueryOptions = (userId?: number) =>
  queryOptions({
    queryKey: ['user', userId],
    // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- the query is only enabled when userId is defined
    queryFn: ({ signal }) => userApi.getUser(userId!, { signal }),
    enabled: !!userId,
  })

export const useUserQuery = (userId?: number) => useQuery(getUserQueryOptions(userId))
